<script lang="ts">
	import { format } from 'svelte-i18n';
	import { MenuItem } from '@Shelly/shelly-design-system';
	import { MENU_ITEMS_IDS, type MenuItems } from 'src/helpers/main_menu';
	import { isActiveHomeShared } from 'src/helpers/houses/homes_helpers';
	import { home_data } from 'src/stores/account/user';
	import { homes } from 'src/stores/account/home';
	import { isEmailUnverified } from 'src/helpers/email_verification_helpers';

	export let menuItems: MenuItems;
	export let itemIndex: number;
	export let activeMenuItem: number;
	export let getActiveIcon: (icon: string) => string;
	export let shouldRenderMenuItem: (item: MenuItems[number]) => boolean;
	export let onMenuItemClick: (itemIndex: number) => void;

	$: item = menuItems[itemIndex];
	$: notification = (() => {
		if (!item) return undefined;
		if (item.href === '/settings' && $isEmailUnverified) return 'danger';
		if (item.id === MENU_ITEMS_IDS.assistant && !$home_data?.aiMenuItemSeen) {
			return 'success';
		}
		return item.notification;
	})();
</script>

{#if item && shouldRenderMenuItem(item)}
	<MenuItem
		class={item.custom ? 'menu-item-custom-icon' : ''}
		active={activeMenuItem === itemIndex}
		icon={activeMenuItem === itemIndex ? getActiveIcon(item.icon) : item.icon}
		label={$format(item.label)}
		{notification}
		on:click={() => onMenuItemClick(itemIndex)}
	/>
{/if}
